export default theme => ({
  jobId: {
    width: 400,
    marginRight: theme.spacing(2)
  },
  jobIdForm: {
    display: 'flex',
    alignItems: 'center'
  },
  descriptionTable: {
    height: 'auto',
    marginTop: '20px'
  }
});
